<template>
  <div id="box">
    <!-- <img class="backImg"  src="../../assets/img/backImg.png"></img> -->
    <div id="container">
      <myhead></myhead>
      <main>
        <div class="left_bg"></div>

        <div class="right_log">
          <div v-if="status == 0">
            <div>
              <span class="blueLine"></span> <span class="title">账号登录</span>
            </div>

            <div class="entry">
              <div class="inputs">
                <el-input
                  @keyup.enter.native="searchEnterFun"
                  placeholder="请输入企业编码"
                  @blur="monitoraccount"
                  v-model.trim="companyInfo.orgCode"
                  style="margin-bottom: 10px; width: 334px"
                  clearable
                >
                  <img
                    class="lettericon"
                    slot="prefix"
                    data-v-4f4f0a06=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABS0lEQVQ4T7WTP0vDUBTFz31Jo2YKCIUWkYLi4OgkuPoZBGdJ/ALlpd2yFNpQzCTYP+DeWfALdOvkpOBSnaSLitAS8+fKA4OpWBTRN9137v1xz3AuAUC7fbadplof4B0iCKW9vxkzXTIL23WPXnI6SH18vzciwkUYxn3DWE6yAaJ4JU35lIiupLTrc6DnecI0y1EcvxY1zbjON13XKTab3QMhyJHS3p8DB4OBNh4/xWnKFhHd5pu6Lg6ThE8AbAB8D+BBCLjVqjOiPFirHT9noOd5ummWJ0RcZ6YbpRNhlxm2lM7mHJhtVBYbjU6pUBBjKe2lVqs7UaBhFLaiKHqcTm1tIRgEnVIUfQ1WKpa+0GoezOwHwbmlNv4Y/Gz1/8FfW/1b0Pd7Q4D3AKhkpB/JIQ3gNQB3uTSpA1gnwpCCILDieNXIR+27Oklm4RtVeh5SwBXISgAAAABJRU5ErkJggg=="
                  />
                </el-input>
                <span class="caveat">{{ account_caveat }}</span>
              </div>
              <div class="inputs">
                <el-input
                  @keyup.enter.native="searchEnterFun"
                  placeholder="请输入手机号"
                  @blur="telePhone"
                  v-model.trim="companyInfo.telePhone"
                  style="margin-bottom: 10px; width: 334px"
                  clearable
                >
                  <img
                    class="lettericon"
                    slot="prefix"
                    data-v-4f4f0a06=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAAjUlEQVQoU2Ps6ZkT++/fvz4GBgYRBuzgDRMTUxFjV9fs9wwMjD7fvj05jk0dF5eMJQPD/y2MXV2z/jMy/hUvLc18hU1hd/d0sf//mV+OYIUMDEyljIwMn7EFz///DLwMDP+6ocHDsPj/f8bv2BQyMv7n/P+fIRYjHLu6Zu8BaSgrS3UB0UgBTmQUEpsoABdGii+HdYXUAAAAAElFTkSuQmCC"
                  />
                </el-input>
                <span class="caveat">{{ account_phone }}</span>
              </div>
              <div class="inputs">
                <el-input
                  type="password"
                  @keyup.enter.native="searchEnterFun"
                  @blur="password"
                  placeholder="请输入登录密码"
                  v-model.trim="companyInfo.password"
                  style="margin-bottom: 10px; width: 334px"
                  clearable
                >
                  <img
                    class="lettericon"
                    slot="prefix"
                    data-v-4f4f0a06=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAABbklEQVQoU4XPP0ubURgF8HNuVOrU1TqWTnZxbFI6128gSIdSEx2EYN5oOhUyWvPeCIUo+esgCOIHENyjrg5OxbFYF4cq2ILvc8SrwXcJvdPD5fecey6ROt53PwNWkfAa4Hkmg7VSKb8zIBwM3ne+mKlBat05dyzpnRm+OoeoXC5sPbiAm83m6PW1+w3w28pKfvM5oL0koXpz8+tVtVq9C7he77wx089MxiZLpcWLAW40tidub+8uRkYwsbxcuAw4jntTQHI2Njb+slj89Cf9j3q99TaKFs5CDe9bOYBzEpZIfpfwb4AlhTBSMnOHrNXaVyT+SjglmTxCS4U7B2gawAt63zGSM1E0f5h+Pj3HcesjwAPGcVsksuVy4WQY3tjoZs3UD1hyudXV+eNhuFbrZp1TP9Qw4/v/YdKOAk4SfKhU8v1hyd73clISaiQkfgDYMzM9Loym9uRIzQIq0vv2roRZAC6dTPJp8eFWJnH/HsX4qSQQ06SpAAAAAElFTkSuQmCC"
                  />
                </el-input>
                <span class="caveat">{{ account_password }}</span>
              </div>
            </div>
            <div class="footerBtn">
              <el-button class="bts" @click="onsubmit">登录</el-button>
            </div>
          </div>
          <div v-if="status == 1">
            <div class="information">
              <div class="avatar" :style="imgObj"></div>
              <div class="name_company">
                <h5>
                  Hi~<span>{{ username }}</span>
                </h5>
                <h6>{{ company }}</h6>
              </div>
            </div>
            <div class="footerBtn">
              <el-button class="bts" @click="alreayEntry">进入工作台</el-button>
              <p @click="logout">注销登录</p>
            </div>
          </div>
        </div>
      </main>
      <myfoot></myfoot>
    </div>
  </div>
</template>

<script>
import bgimg from "../../assets/img/avatar.png";
import {md5} from '../../md5.js'

export default {
  name: "Login",
  data() {
    return {
      status: 1,
      username: "",
      company: "",
      imgObj: "",
      codes: "",
      account_status: false, //认证状态
      account_caveat: "", //账号警告
      account_phone: "", //手机号警告
      account_password: "", //密码警告
      companyInfo: {
        id: "",
        companyId: this.$route.query.companyId,
        companyName: this.$route.query.companyName,
        orgCode: "",
        telePhone: "",
        password: "",
        legalIdno: "",
        sourceType: 0,
      },
      typesOf: 0,
    };
  },
  mounted() {
    //this.typesOf = this.$route.query.typesOf;
  },
  created() {
    this.load();
  },
  methods: {
    alreayEntry() {
      this.$router.push({ path: "main" });
    },
    logout() {
      this.$axios
        .post("login/logout")
        .then((res) => {
          this.$message.success(res.data.message);
          this.load();
          this.$router.push({
            path: "/login",
          });
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    load() {
      this.$axios.get("/login/validLogin").then((res) => {
        //当前用户已登录
        if (res.data.status == 1) {
          this.status = 1;
          this.username = res.data.data.userName;
          this.company = res.data.data.companyName;
          if (res.data.data.portrait) {
            this.imgObj = {
              "background-image": "url(" + res.data.data.portrait + ")",
              "background-size": "100px",
              "background-repeat": "no-repeat",
              "background-position": "center",
            };
          } else {
            this.imgObj = {
              "background-image": "url(" + bgimg + ")",
              "background-size": "100px",
              "background-repeat": "no-repeat",
              "background-position": "center",
            };
          }
        } else {
          this.status = 0;
        }
      });
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      // console.log('回车搜索',keyCode,e);
      if (keyCode == 13) {
        this.onsubmit();
      }
    },

    monitoraccount() {
      //var reg = /^[a-zA-Z0-9_-]{6,16}$/;
      //var yxreg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      //var sjreg = /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/;
      if (this.companyInfo.orgCode == "") {
        this.account_caveat = "请填写企业编码";
        return;
      } else {
        this.account_caveat = "";
      }
    },
    telePhone() {
      if (this.companyInfo.telePhone == "") {
        this.account_phone = "请填写手机号";
        return;
      } else {
        this.account_phone = "";
      }
    },
    password() {
      if (this.companyInfo.password == "") {
        this.account_password = "请填写密码";
        return;
      } else {
        this.account_password = "";
      }
    },
    onsubmit() {
      this.monitoraccount();
      this.telePhone();
      this.password();
      if (this.companyInfo.orgCode == "") {
        return;
      } else if (this.companyInfo.telePhone == "") {
        return;
      } else if (this.companyInfo.password == "") {
        return;
      }
      const params =
            "code=" +
            this.companyInfo.orgCode +
            "&username=" +
            this.companyInfo.telePhone +
            "&userpwd=" +
            md5( this.companyInfo.password)
   

      return this.$axios
        .post(
          "login/login",params
           
        )
        .then((res) => {
          if (res.data.status == 1) {
            // console.log(res.data)
            for (var i = 0; i < res.data.data.length; i++) {
              let vvv = "";
              this.codes += res.data.data[i] + ",";
              var str = this.codes.substring(0, this.codes.length - 1);
            }
            this.codes = str;
            sessionStorage.clear();
            sessionStorage.setItem("btnPermissions", this.codes);
            this.$router.push({
              path: "main",
            });
          } else if (res.data.status == 0) {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          this.$message.error(res.data.message);
        });
    },
    onreturn() {
      // 				this.$router.push({
      // 					path: '/setting/company'
      // 				})

      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="less">
#app {
  // position: relative;
  display: flex;
}

#box {
  width: 100%;
  min-width: 1084px;
  background-color: #292b52;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;
  // overflow-x: hidden;
  .backimg {
    width: 1920px;
    height: 880px;
    background: rgba(47, 46, 75, 1);
    display: flex;
    justify-content: center;
  }
  .inputs {
    position: relative;
    .caveat {
      height: 26px;
      line-height: 26px;
      background-color: #fff;
      position: absolute;
      top: 4px;
      right: 20px;
      color: red;
    }
  }

  #container {
      width: 1084px;
			margin: 0 auto;
    
    main {
      width: 100%;
      height: 550px;
      background-color: #fff;
      border-radius: 6px;
      display: flex;

      overflow: hidden;
      .left_bg {
        width: 664px;
        height: 456px;
        background-image: url(../../assets/img/未标题-2.png);
        background-repeat: no-repeat;
        margin: 50px 0 0 70px;
      }

      .right_log {
        height: 556px;
        width: 433px;
        margin: 100px 150px 0 0;

        .blueLine {
          display: inline-block;
          width: 4px;
          height: 26px;
          background: linear-gradient(
            138deg,
            rgba(95, 105, 241, 1) 0%,
            rgba(115, 92, 201, 1) 100%
          );
          border-radius: 4px;
          vertical-align: text-bottom;
        }

        .desc {
          display: flex;
          align-items: center;
          color: #0bb27a;
          font-size: 14px;
          margin: 10px 0;
        }

        .desc:after {
          content: "";
          width: 40px;
          height: 1px;
          background-color: #a8a8b3;
          margin-left: 20px;
        }

        .desc:before {
          content: "";
          width: 40px;
          height: 1px;
          background-color: #a8a8b3;
          margin-right: 20px;
        }

        .message {
          font-size: 12px;
          color: #555;
          margin-bottom: 30px;
          margin-top: 30px;
          text-align: center;
        }

        .entry {
          margin: 50px 0 32px 0;
        }

        .footerBtn {
          width: 100%;
          // display: flex;
          // justify-content: space-between;
          margin-top: 20px;

          .bts {
            width: 334px;
            height: 34px;
            background: linear-gradient(
              138deg,
              rgba(95, 105, 241, 1) 0%,
              rgba(115, 92, 201, 1) 100%
            );
            border-radius: 4px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;
          }

          p {
            text-align: center;
            width: 100%;
            margin-top: 20px;
            cursor: pointer;
            color: #6669e3;
          }
        }

        .title {
          width: 120px;
          height: 30px;
          font-size: 30px;
          font-weight: bold;
          color: rgba(48, 49, 64, 1);
          line-height: 45px;
        }
      }
    }
  }
}
.information {
  padding: 55px 31px 0;
  box-sizing: border-box;

  .avatar {
    width: 89px;
    height: 89px;
    margin: 0 auto;
    border: 2px solid #e4e6ec;
    border-radius: 50%;

    img {
      width: 89px;
      height: 89px;
    }
  }

  .name_company {
    text-align: center;
    margin-top: 40px;
    // margin-bottom: 57px;

    h5 {
      font-size: 22px;
      margin-bottom: 8px;
      color: #272727;
    }

    h6 {
      font-size: 14px;
      color: #747474;
    }
  }

  .btns {
    text-align: center;

    button {
      border: none;
      width: 100%;
      height: 34px;
      border-radius: 6px;
      min-width: 84px;
      color: #fff;
      font-size: 14px;
      background-color: #6669e3;
      cursor: pointer;
      margin-bottom: 30px;
    }

    button:hover {
      background-color: #8285ff;
    }

    button:active {
      background-color: #5658c5;
    }

    span {
      font-size: 13px;
      cursor: pointer;
      color: #7a81f4;
    }
  }
}
// @media (min-height: 720px) {
//   #container {
//     width: 1084px !important;
//     height: 550px;
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     margin: auto !important;
//   }
// }
.icon {
  width: 6px;
  height: 4px;
  background-image: url(../../assets/img/编组.png);
  background-repeat: no-repeat;
}
.el-input--prefix .el-input__inner {
  padding-left: 25px !important;
}
.lettericon {
  vertical-align: -webkit-baseline-middle;
  //margin-left: -627px;
}

/deep/ .el-input__prefix {
  position: absolute;
  left: 9px;
  text-align: left;
  width: 16px;
}

.inputs /deep/ .el-input--prefix .el-input__inner {
  padding-left: 25px !important;
}
@media (min-height:720px) {
		#container {
			width: 1084px !important;
			height: 720px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto !important;
		}
	}
</style>
